import React, { useContext, useEffect,useState } from "react";
import {Card, AppBar, Toolbar, Typography, IconButton, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid} from "@mui/material";
import { Logout as LogoutIcon, AccountBalanceWallet,Celebration,CurrencyRupee, WarningAmber, Store, List} from "@mui/icons-material";

import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { callPostApi } from "../../function/ApiCallFunction";

import StoreDialog from "../../components/modal/StoreInfoModal";
import ThirdPartyApiInfo from "../../components/modal/ThirdPartyApiInfoModal";
import SellerStoreListInfo from "../../components/modal/SellerStoreListModal";

import partypopper from '../../assets/partypopper.gif';
import cashilogo from '../../assets/cashilogo.png';

import StoreInfoModal from "../../components/modal/StoreInfoModal";
import { DataContext } from "../../context/DataContext";

function Navbar({ onLogout }) 
{
    const navigate = useNavigate();
    const { loginData, setLoginData } = useContext(DataContext);
    const storeInfo = loginData?.store_info || {};

    const store_id           = storeInfo.store_id || "";
    const cashi_plus_welcome = storeInfo.cashi_plus_welcome;
    const store_name         = storeInfo.store_name?.length > 19 ? `${storeInfo.store_name.substring(0, 19)}...` : storeInfo.store_name || "";
    const storeListArr       = Array.isArray(storeInfo.store_list) ? storeInfo.store_list : [];

    const [open,      setOpen]      = useState(false);
    const [claimOpen, setClaimOpen] = useState(false);

    //********* Page Modal ******** */
      // Modal States // type  = 'info', 'approve', 'deny', 'edit','ser_comm', 'ser_edit','location','flag_active','flag_deactive'
      const [modalState, setModalState] = useState({ type: null, data: null, });
  
      const openModal   = (type, data) => { setModalState({ type, data }); };
      const handleClose = () => { setModalState({ type: null, data: null }); };
  
      useEffect(() => {
          const handleEsc = (event) => { if (event.key === 'Escape') { handleClose(); } };
          document.addEventListener('keydown', handleEsc);
          return () => { document.removeEventListener('keydown', handleEsc); };
      }, []);
    //********* Page Modal ******** */
    
    /* -------------------- LOGOUT -------------------- */
    const handleConfirmLogout = () => 
    {
        setOpen(false);
        onLogout();
    };

    /* -------------------- CLAIM WELCOME BONUS -------------------- */
    const handleClaimClick = async () => 
    {
        try 
        {
            const payload   = { mod: "ADD_CASHI_PLUS_WELCOME",data_arr: { store_id }};
            const apiResult = await callPostApi("store-wallet", payload);

            if (apiResult.status === "200") 
            {
                toast.success(apiResult.data.message);

                setLoginData(prev => 
                {
                    const updated = {...prev,store_info: {...prev.store_info,...apiResult.data.store_info, 
                          wallet_amount: Number(prev?.store_info?.wallet_amount || 0) + 500,cashi_plus_welcome: "1" }};

                    sessionStorage.setItem("loginData", JSON.stringify(updated));
                    return updated;
                });

                setClaimOpen(true);
            } 
            else { toast.info(apiResult.status_message); }
        } 
        catch (err) { toast.error("Something went wrong"); }
    };

    return (
    <>
      {/* ===================== NAVBAR ===================== */}
      <AppBar position="sticky" style={{backgroundColor:'#000',marginBottom:'40px' }}>
        <Toolbar sx={{display:'flex', alignItems:'center',justifyContent:'space-between',flexWrap:'wrap'}}>

          <Typography variant="h6">
            <img src={cashilogo} alt="logo" height="30px" width="auto" style={{cursor:'pointer'}} onClick={()=> {navigate('/home')}} />
          </Typography>

          <Box sx={{display:'flex',alignItems:'center',justifyContent:'space-between', flexWrap:'wrap'}}>

            {/* ---------- Welcome Bonus ---------- */}
            {cashi_plus_welcome === "0" && ( 
              <Grid sx={{display:'flex', alignItems:'center',justifyContent:'space-between', flexWrap:'wrap' ,borderRadius:'6px', mx:'10px', px:'7px', py:'5px',
                    backgroundColor:' #f1c12d', color:'#000', my:'5px'}}>
          
                    <Typography sx={{margin:'8px', my:'0px', mx:'5px',}}>
                        <Celebration />  You’ve received a Welcome Bonus of ₹500!
                      <Button sx={{borderRadius:'25px', background:'#000000', color:'#ffffff', fontSize:'12px', mx:1}}
                        onClick={() => handleClaimClick()} >Claim it now</Button>         
                    </Typography>
              </Grid>
            )}

            {/* ---------- Wallet ---------- */}
            <Box sx={{borderRadius:'6px', border:'1px solid #dbdbdbff', mx:'10px', my:'5px', cursor:'pointer',
                display:'flex', alignItems:'center' }}  onClick={()=> navigate('/wallet')} >
               
               <Box sx={{width:'40px'}}> 
                  <Box sx={{px:'7px', py:'5px' , backgroundColor:'#888888', borderTopLeftRadius:'5px',
                      borderBottomLeftRadius:'5px' }}> <AccountBalanceWallet  onClick={()=> navigate('/wallet')} />
                  </Box>
                </Box>

                <Typography sx={{display:'flex', alignItems:'center', px:1}} > <CurrencyRupee /> {Number(loginData?.store_info?.wallet_amount || 0)} </Typography>

            </Box>

            <Button sx={{background:'linear-gradient(195deg, #49a3f1, #1A73E8)', px:'7px', py:'5px', borderRadius:'6px',my:'5px',
                color:'#fff' }} onClick={() => openModal('info',storeInfo)} > <Store /> {store_name} 
            </Button>

            <StoreDialog />

            {storeListArr.length > 1 && (
                <IconButton sx={{background: 'linear-gradient(195deg, #c35920ff, #e68610ff)', color:'#ffffff', borderRadius:'6px' , ml:'10px',
                  my:'5px',}} onClick={() => openModal('SELLER_STORE', storeInfo)} > <List sx={{ fontSize:'20px'}} />
                </IconButton>
                
            )}
            
            {/* ---------- Logout ---------- */}
            <IconButton sx={{background: 'linear-gradient(195deg, #66BB6A, #155c19)', color:'#ffffff', borderRadius:'6px' , ml:'10px',
              my:'5px',}} onClick={() => setOpen(true)} > <LogoutIcon sx={{ fontSize:'20px'}} />
            </IconButton>
      
        </Box>
        
        </Toolbar>
      </AppBar>

      {/* Logout Confirmation Dialog */}
      <Dialog open={open} onClose={() => setOpen(false)}>
          
           <Card sx={{width:'20rem'}}>
              <Box sx={{display:'flex',justifyContent:'center', background:'linear-gradient(195deg, #49a3f1, #1A73E8)', py:2,
                boxShadow: 'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px' }}>
                  <WarningAmber sx={{fontSize:'48px', color:'#ffffff'}}/>
              </Box>
          </Card>

          <DialogContent> <DialogContentText> Are you sure you want to log out? </DialogContentText> </DialogContent>

          <DialogActions> 
              <Button onClick={() => setOpen(false)}>Cancel</Button>
              <Button onClick={handleConfirmLogout}   variant="gradient" autoFocus sx={{background:'linear-gradient(195deg, #49a3f1, #1A73E8)',
                color:'#ffffff'}}> Logout </Button>
          </DialogActions>

      </Dialog>
      
      {/* Claim Success Dialog */}
      <Dialog open={claimOpen} onClose={() => { setClaimOpen(false); navigate("/wallet")} }>
        
        <DialogTitle variant="h4" sx={{textAlign:'center', fontWeight:'bold', }}> Congratulations!
         <Typography><img src={partypopper} alt="party popper" height="250px" width="auto" /> </Typography>
        </DialogTitle>
        
        <DialogContent>
          <DialogContentText variant="h6" sx={{color:'#000', textAlign:'center'}}>
            <span style={{color:'#2bbf67'}}>₹500</span> has been successfully added to your wallet. Enjoy your rewards!
          </DialogContentText>
        </DialogContent>
        
         <DialogActions>
            <Button  fullWidth variant="contained" sx={{background:'linear-gradient(195deg, #66BB6A, #43A047)'}} 
                onClick={() => { setClaimOpen(false); navigate("/wallet"); }} > Go to Wallet </Button>
          </DialogActions>

      </Dialog>

      {modalState.type === 'info'         && ( <StoreInfoModal      dataArr={modalState.data} onClose={handleClose} openModal={openModal} />)}
      {modalState.type === 'API_DOC'      && ( <ThirdPartyApiInfo   dataArr={modalState.data} onClose={handleClose}  />)}
      {modalState.type === 'SELLER_STORE' && ( <SellerStoreListInfo dataArr={modalState.data} onClose={handleClose}  />)}

      </>  
  
  );
}

export default Navbar;
